import {
  API_PROFILE_GET_REQUEST,
  API_PROFILE_GET_SUCCESS,
  API_PROFILE_GET_FAILURE,
  API_PROFILE_PUT_REQUEST,
  API_PROFILE_PUT_SUCCESS,
  API_PROFILE_PUT_FAILURE,
  API_PROFILE_PATCH_REQUEST,
  API_PROFILE_PATCH_SUCCESS,
  API_PROFILE_PATCH_FAILURE,
} from 'common/types';

const initialState = {};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [API_PROFILE_GET_REQUEST]: (state) => {
    return {
      ...state,
      error: undefined,
      loadingProfile: true,
    };
  },
  [API_PROFILE_GET_SUCCESS]: (state, action) => {
    let profile = action.payload;
    return {
      ...profile,
      loadingProfile: false,
    };
  },
  [API_PROFILE_GET_FAILURE]: (state, action) => {
    return {
      ...state,
      loadingProfile: false,
      error: 'Failed to get profile',
    };
  },
  [API_PROFILE_PUT_REQUEST]: (state) => {
    return {
      ...state,
      loadingProfile: true,
    };
  },
  [API_PROFILE_PUT_SUCCESS]: (state, action) => {
    return {
      ...action.payload,
      loadingProfile: false,
    };
  },
  [API_PROFILE_PUT_FAILURE]: (state, action) => {
    return {
      ...state,
      loadingProfile: false,
      error: action.payload.response.message,
    };
  },
  [API_PROFILE_PATCH_REQUEST]: (state) => {
    return {
      ...state,
      loadingProfile: true,
    };
  },
  [API_PROFILE_PATCH_SUCCESS]: (state, action) => {
    return {
      ...action.payload,
      loadingProfile: false,
    };
  },
  [API_PROFILE_PATCH_FAILURE]: (state, action) => {
    return {
      ...state,
      loadingProfile: false,
      error: action.payload.response.message,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
